import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dimmer,
  Grid,
  Header,
  Loader,
  Button,
  Segment,
  Message,
  Divider,
  Icon,
  Dropdown,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { fetchM } from '../actions/fetchM';
import { flashMessage, flashErrorMessage } from '../actions/flash';
import config from '../../config';

export default class LPPSAChecker extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    loading: PropTypes.bool,
    token: PropTypes.string,
    type: PropTypes.oneOf(['booking', 'customer']).isRequired,
    bookingID: PropTypes.string,
    onChange: PropTypes.func,
    newHeader: PropTypes.string,
  }
  static defaultData = {
    lppsaResultStatusID: '',
    lppsaResultID: '',
    lppsaResult: {
      name: '',
      key: '',
    },
  };
  static getPropsToState = (props) => {
    const token = props.token;
    const loading = props.loadng;
    const data = Object.assign({}, LPPSAChecker.defaultData, props.data);
    return {
      data,
      token,
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = LPPSAChecker.getPropsToState(props);
    this.state = {
      ...state,
      token: props.token,
      file: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = LPPSAChecker.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  submitFile(body) {
    this.setLoading(true);
    const { store } = this.context;
    const { data } = this.state;
    let url;
    switch (this.props.type) {
      case 'booking':
        url = `/bookings/${this.props.bookingID}/customer/${data.id}/lppsa/`;
        break;
      case 'customer':
        url = `/customers/${data.id}/lppsa/`;
        break;
      default:
        break;
    }
    store.dispatch(fetchM(url, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'X-Csrf-Token': this.props.token,
      },
      body,
    })).then((res) => {
      this.setLoading(false);
      res.text().then((message) => {
        const json = JSON.parse(message);
        if (json) {
          data.lppsaResultID = json.id;
          data.lppsaResult.name = json.name;
          data.lppsaResult.key = json.key;
          this.setState({ data }, () => {
            if (this.props.onChange) this.props.onChange(data);
            store.dispatch(flashMessage({ header: 'Upload Success', message: 'File Successfully Uploaded', icon: 'checkmark', type: 'success', autoHideDuration: 10000 }));
          });
        }
      });
    }).catch((err) => {
      this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        err.res.text().then((message) => {
          store.dispatch(flashErrorMessage({ message }));
        });
        this.setState({ file: null });
        return;
      }
      store.dispatch(flashErrorMessage(err));
    });
  }
  handleAddFile = (e) => {
    e.preventDefault();
    this.lppsa_upload.click();
  }
  handleOnChange = () => {
    const files = Array.prototype.slice.call(this.lppsa_upload.files);
    this.lppsa_upload.value = null;
    if (window.FileReader) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.setState({ file }, () => {
            this.handleSubmit();
          });
        };
        reader.readAsDataURL(file);
      });
    }
  }
  handleSubmit = () => {
    const formData = new FormData();
    formData.append('lppsa_upload', this.state.file);
    this.submitFile(formData);
  }
  handleDismiss = () => {
    const { data } = this.state;
    data.lppsaResult.name = '';
    data.lppsaResult.key = '';
    data.lppsaResultID = '';
    this.setState({ file: null, data }, () => {
      if (this.props.onChange) this.props.onChange(data);
    });
  }
  handleOnDDChange = (e, { value }) => {
    e.preventDefault();
    const { data } = this.state;
    data.lppsaResultStatusID = value;
    this.setState({ data }, () => {
      if (this.props.onChange) this.props.onChange(data);
    });
  }
  LPPSA_STATUS = [
    { text: 'Passed', value: 'Passed' },
    { text: 'Failed', value: 'Failed' },
  ];
  render() {
    const { newHeader } = this.props;
    const { file, data } = this.state;
    return (
      <div>
        <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
          <Loader inline="centered">Loading</Loader>
        </Dimmer>
        <form
          encType="multipart/form-data"
          onSubmit={this.handleSubmit}
          ref={(ref) => { this.form = ref; }}
          style={{ display: 'none' }}
        >
            Select file to upload:
          <input
            id="lppsa_upload"
            name="lppsa_upload"
            onChange={this.handleOnChange}
            ref={(ref) => { this.lppsa_upload = ref; }}
            type="file"
          />
        </form>
        { newHeader &&
          <Header className="new_title" as="h5" attached="top">
            {newHeader}
          </Header>
        }
        <Segment
          attached={newHeader ? true : false}
          textAlign="center"
        >
          <p>
            Please ensure popups are not blocked, <br />
            Clicking this will bring you to a new tab, <br />
            Download the attachment and upload below, <br />
          </p>
          <Link
            as="a"
            className="ui medium primary button"
            to="http://www.lppsa.gov.my/v2/kalkulator-pembiayaan/"
            target="_blank"
          >
            Check eligibility in LPPSA
          </Link>
          <Divider hidden />
          <Grid centered padded>
            <Grid.Row style={{ padding: '0 0 0.5em' }}>
              <Grid.Column mobile={16} tablet={10} computer={7} textAlign="left">
                <p><b>LPPSA Result Page Screenshot</b></p>
                {(file && file.name) || (data.lppsaResult && data.lppsaResult.name) ?
                  <Message
                    className="import_file_selcted"
                    info
                    onDismiss={this.handleDismiss}
                    size="tiny"
                  >
                    <Link
                      as="a"
                      to={data.lppsaResult ? `${config.get('bookApiURL')}/customers/${data.id}/lppsa/${data.lppsaResultID}/${data.lppsaResult.name}` : '#'}
                      target="_blank"
                    >
                      <b>{(file && file.name) || (data.lppsaResult && data.lppsaResult.name)}</b>
                    </Link>
                  </Message>
                  :
                  <Button
                    basic
                    fluid
                    onClick={this.handleAddFile}
                    style={{ marginBottom: '0.5em' }}
                  >
                    <Icon name="plus" /> Upload file
                  </Button>
                }
                <Divider hidden />
                <p><b>Select Result Status</b></p>
                <Dropdown
                  disabled={this.state.loading}
                  fluid
                  onChange={this.handleOnDDChange}
                  options={this.LPPSA_STATUS}
                  placeholder={'Select Status'}
                  selection
                  selectOnBlur={false}
                  value={data.lppsaResultStatusID}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LPPSAChecker.jsx